import { Pipe, PipeTransform } from '@angular/core';
import { UIType } from '@building-blocks/ecertnl-kolommen-instellen/kolom.model';
import { DatePipe } from '@angular/common';
import { NumberValuePipe } from '@pipes/number-value.pipe';
import { ApiValueType } from '@util-services';
import { isEmptyValue } from '@helpers';

// timezone europe/amsterdam zodat front-end de juiste wintetijd/zomertijd bepaalt.
// CET of CEST werkt hier niet, deze zijn of zomer of wintertijd en dus niet dynamisch afhankelijk van de waarde.
const timezone = 'Europe/Amsterdam';
const locale = 'nl-nl';

@Pipe({
  name: 'ecertFormat',
  standalone: false,
})
export class EcertFormatPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, private numberValuePipe: NumberValuePipe) {}

  async transform(waarde: ApiValueType | Promise<ApiValueType>, typeDetails: UIType): Promise<string> {
    if (waarde instanceof Promise) {
      return waarde.then((vasteWaarde) => this.transformSync(vasteWaarde, typeDetails));
    }
    return this.transformSync(waarde, typeDetails);
  }

  transformSync(waarde: ApiValueType, typeDetails: UIType): string {
    if (isEmptyValue(waarde)) {
      return waarde as string;
    }

    let geformatteerdeWaarde = waarde.toString();
    try {
      if (typeDetails.datum) {
        geformatteerdeWaarde = this.datePipe.transform(geformatteerdeWaarde, 'dd-MM-yyyy', timezone, locale);
      }
      if (typeDetails.datumTijd) {
        geformatteerdeWaarde = this.datePipe.transform(geformatteerdeWaarde, 'dd-MM-yyyy HH:mm', timezone, locale);
      }
      if (typeDetails.tijd) {
        geformatteerdeWaarde = this.datePipe.transform(geformatteerdeWaarde, 'HH:mm', timezone, locale);
      }
    } catch (_) {
      // als waarde niet naar datum en/of tijd geconverteerd kan worden, dan de originele waarde doorgeven
    }
    if (typeDetails.nummer) {
      geformatteerdeWaarde = this.numberValuePipe.transformSync(geformatteerdeWaarde);
    }

    return geformatteerdeWaarde;
  }
}
